"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcIsHighlighting = void 0;
function calcIsHighlighting(groups, node, propogateUpwardsOnly = false) {
    if (!(groups === null || groups === void 0 ? void 0 : groups.length))
        return false;
    let highlighted = false;
    if (!highlighted && node.group) {
        highlighted = !!groups.find(g => g.queryFieldKey === node.group.queryFieldKey && g.id === node.group.id);
    }
    if (!highlighted && node.parentNode) {
        highlighted = calcIsHighlighting(groups, node.parentNode, true);
    }
    if (!propogateUpwardsOnly && !highlighted && node.childNodes) {
        highlighted = node.childNodes.some(childNode => calcIsHighlighting(groups, childNode));
    }
    return highlighted;
}
exports.calcIsHighlighting = calcIsHighlighting;
exports.default = calcIsHighlighting;
